
export const searchHomes = (homes, searchQuery) => {
    return homes.filter((home) => (
        home.title && home.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        home.link && home.link.toLowerCase().includes(searchQuery.toLowerCase()))
    )
};

